import { memo, useContext, useEffect, useState } from 'react';
import { MovableTypePrintingContext } from './MovableTypePrintingProvider';
import GamePrintingSquare from './GamePrintingSquare';

interface GamePrintingSquaresProps {
}

export default function GamePrintingSquares(props: GamePrintingSquaresProps) {
  const { total } = useContext(MovableTypePrintingContext);
  const [squaresByColumn, setSquaresByColumn] = useState([[]]);

  useEffect(() => {
    // console.log(total);
    setSquaresByColumn(Array(2).fill(Array(Math.ceil(total / 2)).fill(null)));
  }, [total]);

  return (<div className={`game-printing-squares game-printing-squares-2-${Math.ceil(total / 2)}`}>
    <div>
      <div>
        {squaresByColumn.map((squares, columnIndex) => <div key={columnIndex} className={`game-printing-squares-board-column`}>
          {squares.map((_, i) => <GamePrintingSquare key={i} index={columnIndex * Math.ceil(total / 2) + i}></GamePrintingSquare>)}
        </div>)}
      </div>
    </div>
  </div>)
}
